import { fromLonLat } from 'ol/proj';
import React, { useContext } from 'react';

import { MapContext } from './map-context';
import { PlayerContext } from '../../contexts/player';
import { MapEntity } from '../../types/game-document/entities';
import { MapIllustrationContext } from './map-illustration-context';

const MapResetView: React.FC<{ currentMap: MapEntity | undefined }> = ({
  currentMap
}) => {
  const [player] = useContext(PlayerContext);

  const map = React.useContext(MapContext);
  const mapIllustration = React.useContext(MapIllustrationContext);

  const handleResetView = React.useCallback(() => {
    if (!currentMap) return;
    if (currentMap?.type === 'illustrated' && !mapIllustration) return;
    if (currentMap?.type !== 'illustrated' && !map) return;

    let view = map.getView();
    if (currentMap.type === 'illustrated') view = mapIllustration.getView();

    const position =
      currentMap.type !== 'illustrated'
        ? fromLonLat([
            player.playerState?.coordinates?.longitude ?? 0,
            player.playerState?.coordinates?.latitude ?? 0
          ])
        : [currentMap.longitude ?? 0, currentMap.latitude ?? 0];

    view.animate({
      center: position,
      zoom: currentMap.zoomLevel,
      duration: 300
    });
  }, [
    map,
    currentMap,
    player.playerState?.coordinates?.longitude,
    player.playerState?.coordinates?.latitude
  ]);

  return (
    <div className="d-flex align-items-center justify-content-center p-2 rounded-circle map-reset-view">
      <div
        className="d-flex align-items-center justify-content-center rounded-circle p-2 bg-white cursor-pointer"
        style={{
          height: '32px',
          width: '32px'
        }}
        onClick={handleResetView}>
        <img
          src="/reset-view.svg"
          alt="Reset view"
          style={{
            height: '18px',
            width: '18px'
          }}
        />
      </div>
    </div>
  );
};

export default MapResetView;
